import styled from 'styled-components'

export const SelectWrapper = styled.div`
  display: grid;
  gap: 8px;
  width: 230px;
`
